(() => {
  function start(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const track = root.querySelector('.fanorama-review-track');
    const previous = root.querySelector('[data-review-prev]');
    const next = root.querySelector('[data-review-next]');
    const summary = root.querySelector('.fanorama-reviews-summary');
    const position = root.querySelector('.fanorama-review-position');
    let reviews = JSON.parse(root.querySelector('[data-review-seed]').textContent || '[]');
    function updatePosition() {
      const cards = Array.from(track.children);
      const width = cards[0]?.getBoundingClientRect().width || 1;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const first = Math.min(cards.length, Math.round(track.scrollLeft / (width + gap)) + 1);
      const shown = Math.max(1, Math.floor((track.clientWidth + gap) / (width + gap)));
      position.textContent = cards.length ? `Showing ${first}–${Math.min(cards.length, first + shown - 1)} of ${cards.length} reviews` : '';
      previous.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    function updateSummary() {
      if (!reviews.length) return;
      root.hidden = false;
      const average = Math.round(reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length * 100) / 100;
      summary.textContent = `${average} out of 5 · ${reviews.length} ${reviews.length === 1 ? 'review' : 'reviews'} for this product`;
      const node = document.getElementById('fanorama-product-schema');
      if (node) {
        try {
          const schema = JSON.parse(node.textContent);
          schema.aggregateRating = {'@type':'AggregateRating', ratingValue:average, ratingCount:reviews.length, bestRating:5, worstRating:1};
          schema.aggregateRating.reviewCount = reviews.length;
          // Product descriptions should describe the product, without the former
          // embedded review transcript; the reviews now have their own section.
          if (schema.description) schema.description = schema.description.split('Customer reviews from Etsy')[0].trim();
          node.textContent = JSON.stringify(schema);
        } catch (error) { console.warn('Fanorama review schema could not be updated.'); }
      }
      updatePosition();
    }
    function card(r) {
      const article = document.createElement('article');
      article.className = 'fanorama-review-card';
      article.dataset.reviewId = r.id;
      const stars = document.createElement('div');
      stars.className = 'fanorama-review-stars';
      stars.setAttribute('aria-label', `${r.rating} out of 5 stars`);
      stars.textContent = '★'.repeat(r.rating) + '☆'.repeat(5-r.rating);
      const body = document.createElement('p');
      body.className = 'fanorama-review-body';
      body.textContent = r.body || 'Rating only';
      const footer = document.createElement('footer');
      const author = document.createElement('strong');
      author.textContent = r.author;
      const meta = document.createElement('span');
      const date = document.createElement('time');
      date.dateTime = r.date;
      date.textContent = r.date;
      meta.append(date, ' · ');
      if (r.source === 'etsy') {
        const link = document.createElement('a');
        const url = new URL(r.sourceUrl);
        if (url.protocol === 'https:' && url.hostname === 'www.etsy.com') {
          link.href = url.href; link.target = '_blank'; link.rel = 'noopener';
          link.textContent = 'Reviewed on Etsy'; meta.append(link);
        }
      } else meta.append('Verified Fanorama purchase');
      footer.append(author, meta); article.append(stars, body, footer);
      return article;
    }
    const move = direction => track.scrollBy({left:direction * track.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updatePosition, {passive:true});
    const resize = new ResizeObserver(updatePosition); resize.observe(track);
    updateSummary();
    fetch('https://studio.fanorama.art/api/reviews?product=' + encodeURIComponent(root.dataset.product), {credentials:'omit'})
      .then(response => {if (!response.ok) throw Error('Unavailable'); return response.json();})
      .then(data => {
        if (!Array.isArray(data.reviews) || !data.reviews.length) return;
        reviews = data.reviews;
        // Avoid replacing already-rendered Etsy cards when there are no additions.
        if (reviews.map(r=>r.id).join(',') !== Array.from(track.children).map(c=>c.dataset.reviewId).join(',')) track.replaceChildren(...reviews.map(card));
        updateSummary();
      }).catch(() => {/* The server-rendered Etsy reviews remain usable. */});
  }
  const initialize = () => document.querySelectorAll('.fanorama-reviews').forEach(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
